import axios from 'axios'
import {getCredential, removeStorageAndLogout, showErrorToast} from '../helpers/CommonHelper';
import encryptionService from "./encryptionService";

const config = {
    timeout: 0,
    withCredentials: false
}

if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
    // config.baseURL = process.env.REACT_APP_API_ROOT;
    // config.baseURL = 'https://godigidev.mblbd.com';
    config.baseURL = "http://localhost:10734/ib-core-gw-1.0";
}

const api = axios.create(config);
let loaderCount = 0;

api.interceptors.request.use((config) => {
    try {
        let params = config.params;
        if (params === undefined) {
            params = {};
        }
        let credentials = {};

        if (config.url.match("/login")) {
            config.headers = {...config.headers, ...credentials}
        } else if (config.url.match("/logout")) {
            ///todo: session clearing
        } else if (config.url.match('/api/')
            && !config.url.match('/api/users/')
            && ['post', 'put', 'delete'].includes(config.method)
            && encryptionService.ENABLED_PAYLOAD_ENCRYPTION === true) {
            config = encryptionService.encryptPayload(config);

        }
        if (config.url.match('/api/') && ['post', 'put', 'delete'].includes(config.method)) {
            params['_csrf'] = sessionStorage.getItem('_csrf');
            config.params = params;
        }

        if (!config.url.match("/login")
            && !config.url.match("/users/register")
            && !config.url.match("/send-registration-otp")
            && !config.url.match("/users/first-change-password")
            && !config.url.match("/users/set-forgotten-password")
            && !config.url.match("/users/set-forgotten-pin-and-password")
            && !config.url.match("/users/map/check-otp")
            && !config.url.match("/users/map/resend-map-otp")
            && !config.url.match("/users/verify-user")
            && !config.url.match("/users/access-link")
            && !config.url.match("/policy/PASSWORD")
        ) {
            try {
                credentials = getCredential();
                params['Authorization'] = "bearer " + credentials.token;
            } catch (e) {
                console.log("Error while fetching from Local store", e)
            }
            if (Object.keys(credentials).length === 0) {
                window.location.href = '/login'
                return;
            }
        }
        config.headers = {
            ...config.headers, "X-KM-User-Id": credentials.userId,
            "X-KM-Asp-Id": 100013000000001,
            "Authorization": "Bearer " + credentials.token,
            "X-KM-Access-Token": credentials.token,
            "X-KM-Refresh-Token": credentials.refreshToken,
            "X-KM-User-Agent": "WEB",
        };
        config.params = {
            ...config.params,
            Authorization: "Bearer:" + credentials.token,
            "X-KM-Asp-Id": 100013000000001,
            "X-KM-User-Id": credentials.userId,
            "userId": credentials.userId,
            "_csrf": sessionStorage.getItem("_csrf")
        };

        //Show Loader
        document.getElementsByClassName("center-spinner")[0].style.display = "inline-block";
        document.getElementById("full-spinner").style.display = "inline-block";

        loaderCount++;

        if (config.url.match("/api/users/refresh-access-token")) {
            document.getElementsByClassName("center-spinner")[0].style.display = "none";
            document.getElementById("full-spinner").style.display = "none";
        }

    } catch (e) {
        console.log("Interceptor error: ", e);
    }
    return config;
});

api.interceptors.response.use((res) => {
    if (['post', 'put', 'delete'].includes(res.config.method)) {
        if (res.config.url.match('/api/')) {
            if (res.headers['_csrf'] !== undefined) {
                sessionStorage.setItem("_csrf", res.headers['_csrf']);
            }
        }
    }

    //Hide Loader
    loaderCount--;
    if (loaderCount === 0) {
        document.getElementsByClassName("center-spinner")[0].style.display = "none";
        document.getElementById("full-spinner").style.display = "none";
    }

    return res;
}, (err) => {
    //Hide Loader
    loaderCount--;
    document.getElementsByClassName("center-spinner")[0].style.display = "none";
    document.getElementById("full-spinner").style.display = "none";

    const isLoginUrl = err?.response?.config?.url === "/api/users/login";

    showErrorToast(err);

    // Unauthorized User
    if (err.response?.status === 401 && !isLoginUrl) {
        removeStorageAndLogout();
    }
    return Promise.reject(err);
});

export default api;
